import api from "./api";

interface sessionData {
  userId: number;
  openDate: string;
  workstationId: number;
  isPaused: boolean;
}
interface sessionEditData {
  openDate: string;
  workstationId: number;
  isPaused: boolean;
}


export type Type = {
 closeDate:string
};

export const getSessions = async () => {
  return await api.get("/sessions");
};
export const getSession = async (id: number) => {
  return await api.get(`/sessions/${id}`);
};
export const deleteSession = async (id: number) => {
  return await api.delete(`/sessions/${id}`);
};
export const createSession = async (session: sessionData) => {
  return await api.post("/sessions", session);
};
export const editSession = async (id: number, sessionData: sessionEditData) => {
  return await api.post(`/sessions/${id}`, sessionData);
};
export const closeSession = async (id: number,body:Type) => {
  return await api.patch(`/sessions/${id}`,body);
};
export const pauseSession = async (id: number, isPaused: boolean) => {
  return await api.patch(`/sessions/${id}/pause`, { isPosed: isPaused });
};
export const continueSession = async (id: number, isPaused: boolean) => {
  return await api.patch(`/sessions/${id}/continue`, isPaused);
};
